import axios, { AxiosResponse } from 'axios'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { IMoneyAccount, ITransactions } from 'safe'
import {
  AccountTypes,
  ADD_ACCOUNT,
  CLEAN_TRANSACTIONS,
  DELETE_ACCOUNT,
  SET_ACCOUNTS,
  SET_ACCOUNT_VISIBLE,
  SET_MOVEMENT_ACCOUNT,
  UPDATE_ACCOUNT,
  UPDATE_ACCOUNT_BALANCE,
} from './actionTypes'

const server = process.env.REACT_APP_SERVER_URL

const setAccounts = (accounts: IMoneyAccount[]): AccountTypes => ({
  type: SET_ACCOUNTS,
  payload: accounts,
})

const addAccountMethod = (account: IMoneyAccount): AccountTypes => ({
  type: ADD_ACCOUNT,
  payload: account,
})

export const updateAccountMethod = (updatedAccount: IMoneyAccount): AccountTypes => ({
  type: UPDATE_ACCOUNT,
  payload: updatedAccount,
})

const deleteAccountMethod = (id: string): AccountTypes => ({
  type: DELETE_ACCOUNT,
  payload: id,
})

const setAccountVisibleMethod = (
  id: string,
  visible: boolean
): AccountTypes => ({
  type: SET_ACCOUNT_VISIBLE,
  payload: {
    id: id,
    visible: visible,
  },
})

const setUpdateBalance = (id: string, amount: string): AccountTypes => ({
  type: UPDATE_ACCOUNT_BALANCE,
  payload: {
    id,
    amount,
  },
})

const setMovement = (
  transactions: ITransactions[],
  numberOfPages
): AccountTypes => ({
  type: SET_MOVEMENT_ACCOUNT,
  payload: { transactions, numberOfPages },
})

const cleanTrans = (): AccountTypes => ({
  type: CLEAN_TRANSACTIONS,
})

export const fectchAccounts =
  (): ThunkAction<Promise<void>, {}, {}, AccountTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, AccountTypes>) => {
    try {
      const response: AxiosResponse<{
        status: number
        accounts: IMoneyAccount[]
      }> = await axios.get(`${server}/finances/account`)
      dispatch(setAccounts(response.data.accounts))
    } catch (error) {
      throw error
    }
  }

export const addAccount =
  (account: IMoneyAccount): ThunkAction<Promise<void>, {}, {}, AccountTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, AccountTypes>): Promise<any> => {
    try {
      const response: AxiosResponse<{
        status: number
        account: IMoneyAccount
      }> = await axios.post(`${server}/finances/account`, account)
      console.log('response: ', response)
      dispatch(addAccountMethod({...response.data.account, accountVisible: true}))
      return response
    } catch (error) {
      throw error
    }
  }

export const updateAccount =
  (account: IMoneyAccount): ThunkAction<Promise<void>, {}, {}, AccountTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, AccountTypes>): Promise<void> => {
    console.log("account", account)
    try {
      const response: AxiosResponse<{
        status: number
        account: IMoneyAccount
      }> = await axios.patch(`${server}/finances/account`, account)
      dispatch(updateAccountMethod(response.data.account))
    } catch (error) {
      throw error
    }
  }

export const deleteAccount =
  (id: string): ThunkAction<Promise<void>, {}, {}, AccountTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, AccountTypes>): Promise<any> => {
    try {
      const response: AxiosResponse<{
        status: number
        account: {
          id: string
        }
      }> = await axios.delete(`${server}/finances/account?id=${id}`)
      // console.log('response: ', response)

      dispatch(deleteAccountMethod(response.data.account.id))
      return response
    } catch (error) {
      throw error
    }
  }

export const setAccountVisible =
  (
    id: string,
    visible: boolean
  ): ThunkAction<Promise<void>, {}, {}, AccountTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, AccountTypes>): Promise<void> => {
    try {
      const response: AxiosResponse<{
        status: number
        updatedAccount: {
          idAccount: string
          accountVisible: boolean
        }
      }> = await axios.patch(`${server}/finances/account/visible/${id}`, {
        visible,
      })
      // console.log('response: ', response)
      dispatch(
        setAccountVisibleMethod(
          response.data.updatedAccount.idAccount,
          response.data.updatedAccount.accountVisible
        )
      )
    } catch (error) {
      throw error
    }
  }

export const setBalance =
  (account: {
    amount: string
    description: string
    details: string
    idAccount: string
    transactionType: string
  }): ThunkAction<Promise<void>, {}, {}, AccountTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, AccountTypes>): Promise<void> => {
    try {
      const response: AxiosResponse<{
        status: number
        updatedBalance: { idAccount: string; balance: string }
      }> = await axios.post(`${server}/finances/account/balance`, {
        payments: [account],
      })
      dispatch(
        setUpdateBalance(
          response.data.updatedBalance.idAccount,
          response.data.updatedBalance.balance
        )
      )
    } catch (error) {
      throw error
    }
  }

export const fetchTransactions =
  (
    id: string,
    querySearch: string[],
    paginationParams: string[] = []
  ): ThunkAction<Promise<void>, {}, {}, AccountTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, AccountTypes>): Promise<void> => {
    try {
      const response: AxiosResponse<{
        status: number
        transactions: ITransactions[]
        numberOfPages: number
      }> = await axios.get(
        `${server}/business/transaction/account/${id}?${[
          ...paginationParams,
          ...querySearch,
        ].join('&')}`
      )
      dispatch(
        setMovement(response.data.transactions, response.data.numberOfPages)
      )
    } catch (error) {
      throw error
    }
  }

export const cleanTransactions = () => {
  return cleanTrans()
}
